module.exports = __webpack_public_path__ + "static/media/nft.def3ba5d.jpg";